import Static from '@assets/static-vcr.gif';
import React from 'react';
import styled from 'styled-components';
import { TopNotch } from '../../../components/GlobalStyles';
import { H2, H3, H5, H6 } from '../../../components/Typography/Typography';
import { Colors } from '../../../constants';
import { CurvedArrow, SVG } from '../../../icons/Icons';
import { media } from '../../../components/style-utils';

export const SectionSecret = function() {
  return (
    <Container>
      <BackgroundImage />
      <GradientOverlay />
      <TopNotch color={'var(--colorWhite)'} />

      <TextBox>
        <BoxHeader>
          <span style={{ color: Colors.Primary }}>THE SECRET</span> TO SOCIAL&nbsp;MEDIA
        </BoxHeader>

        <Intro>Want to know the secret to social media? It’s actually quite simple - it’s just two words:</Intro>

        <Label>Time and Attention.</Label>

        <Statement>The amount of time and attention we freely give to social platforms is unprecedented.</Statement>

        <Question>WHAT DOES THIS MEAN FOR&nbsp;YOUR&nbsp;CHURCH?</Question>

        <Statement2>Well, do me a favor and think about what your church wants to accomplish most…</Statement2>

        <List>
          <ListItem>Is it an explosion of new visitors or growth in numbers?</ListItem>
          <ListItem>Increased giving?</ListItem>
          <ListItem>More community outreach?</ListItem>
          <ListItem>More people volunteering and part of small groups?</ListItem>
          <ListItem>Connecting with young people?</ListItem>
        </List>

        <Statement3>Whatever it is - social media can help make it happen.</Statement3>

        <Closing>
          And I can show you how.
          <StyledArrow />
        </Closing>
      </TextBox>
      <Slant />
    </Container>
  );
};

const Container = styled.section`
  margin: 0;
  position: relative;
  width: 100vw;

  margin-bottom: -4rem;

  line-height: 0;
`;

const TextBox = styled.div`
  padding: 12rem 1rem 4rem;

  color: var(--colorWhite);
  text-align: center;

  ${media.desktopAndUp`
    padding-bottom: 0;
  `}
`;

const Statement = styled.p`
  font-weight: 300;
  font-size: 2.1rem;
  line-height: calc(2.4 / 2.1 * 1em);
  letter-spacing: calc(-1 / 2.1 * 0.1em);

  max-width: 20em;
  margin-left: auto;
  margin-right: auto;
`;

const Statement2 = styled(Statement)`
  max-width: 22em;
  margin-top: 0.1em;
`;

const Statement3 = styled(Statement)`
  max-width: none;
  margin-bottom: 0;
`;

const Intro = styled(Statement)`
  font-weight: 500;

  max-width: 18em;
  margin-left: auto;
  margin-right: auto;
`;

const Question = styled(H5)`
  margin-top: 3rem;
  margin-bottom: 0.5rem;
`;

const List = styled.ul`
  padding-left: 7rem;
  padding-right: 2rem;

  text-align: left;
  list-style-type: disc;

  max-width: 22em;
  margin-left: auto;
  margin-right: auto;

  ${media.tabletPortraitAndUp`
    max-width: 18em;
  `}
`;

const ListItem = styled.li`
  font-weight: 700;
  font-size: 2.1rem;
  line-height: calc(3 / 2.1 * 1em);
  letter-spacing: calc(-1 / 2.1 * 0.1em);
`;

const Closing = styled(H6)`
  margin-top: 0;
  display: inline-block;

  position: relative;
`;

const StyledArrow = styled(CurvedArrow)`
  display: none;

  width: 13rem;
  color: var(--colorWhite);
  position: absolute;
  bottom: 0;
  right: 0;

  transform: translate(90%, 65%);

  ${media.tabletLandscapeAndUp`
    display: block;
  `}
`;

const Label = styled(H3)`
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  padding: 1.5rem 2rem;

  background-color: var(--colorPrimaryMedium);
  color: var(--colorWhite);
  border-radius: 1rem;
`;

const BackgroundImage = styled.div`
  z-index: -2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-image: url(${Static});
  background-size: cover;
`;

const GradientOverlay = styled.div`
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.57) 13%, rgba(0, 0, 0, 0.73) 78%);
`;

function BoxHeader(props) {
  return (
    <Box>
      <BoxFront>
        <BoxFrontPanel skew="5deg" />
        <BoxFrontPanel skew="-5deg" />
        <BoxTitle>{props.children}</BoxTitle>
      </BoxFront>
      <StyledBoxBottomPanel />
    </Box>
  );
}

const Box = styled.div`
  max-width: 120rem;
  margin-left: auto;
  margin-right: auto;

  padding-left: 1rem;
  padding-right: 1rem;
`;

const BoxTitle = styled(H2)`
  z-index: 10;
  position: relative;
  margin: 0;
  padding: 1.5rem 0rem;
  text-align: center;

  color: var(--colorBlack);
  font-weight: 900;

  ${media.tabletPortraitAndUp`
    padding-left: 5rem;
    padding-right: 5rem;
  `}
`;

const BoxFront = styled.div`
  position: relative;
`;

const BoxFrontPanel = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-color: var(--colorWhite);
  transform-origin: 50% 100%;
  transform: skewX(${(props) => props.skew});
`;

const BoxBottomPanel = function(props) {
  return (
    <SVG {...props} preserveAspectRatio="none" viewBox="0 0 375 65">
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="150%" id="a">
          <stop stopColor="#F3F3F3" offset="0%" />
          <stop stopColor="#383838" offset="100%" />
        </linearGradient>
        <path id="b" d="M0 0 H 375 L 320 65 H 55 Z" />
      </defs>
      <use fill="url(#a)" xlinkHref="#b" fillRule="evenodd" />
    </SVG>
  );
};

const StyledBoxBottomPanel = styled(BoxBottomPanel)`
  width: 100%;
  height: 3rem;
`;

const Triange = function(props) {
  return (
    <SVG viewBox="0 0 400 60">
      <path fill="white" d="M0 0 L 400 60 H 0 Z" fillRule="evenodd" />
    </SVG>
  );
};

const Slant = styled(Triange)`
  margin: 0;
  padding: 0;
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionSecret.js